const InputResetIcon: React.FC = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM13.707 6.29297C13.3165 5.90244 12.6835 5.90244 12.293 6.29297L10 8.58594L7.70703 6.29297C7.31651 5.90244 6.68349 5.90244 6.29297 6.29297C5.90244 6.68349 5.90244 7.31651 6.29297 7.70703L8.58594 10L6.29297 12.293C5.90244 12.6835 5.90244 13.3165 6.29297 13.707C6.68349 14.0976 7.31651 14.0976 7.70703 13.707L10 11.4141L12.293 13.707C12.6835 14.0976 13.3165 14.0976 13.707 13.707C14.0976 13.3165 14.0976 12.6835 13.707 12.293L11.4141 10L13.707 7.70703C14.0976 7.31651 14.0976 6.68349 13.707 6.29297Z"
      fill="#D9D9D9"
      fillOpacity="0.2"
    />
  </svg>
);

export default InputResetIcon;
